import {Button, Modal, ModalFooter, ModalHeader} from "reactstrap";
import React, {Component} from "react";
import {FaIcon} from "../FaIcon";
import {SaveButton} from "../business_units/SaveButton";

export class YesNoModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: this.props.isOpen
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
        this.handleYesAnswer = this.handleYesAnswer.bind(this);
        this.handleNoAnswer = this.handleNoAnswer.bind(this);

    }

    componentDidUpdate(prevProps) {
        const currentIsOpen = prevProps.isOpen;
        const nextIsOpen = this.props.isOpen;

        if (currentIsOpen !== nextIsOpen) {
            this.setState({modal: nextIsOpen});
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit() {
        this.toggle();
        this.props.afterSuccessfulSubmit();
    }

    handleYesAnswer() {
        this.props.onYesAnswer();
    }

    handleNoAnswer() {
        this.toggle()

        if(this.props.onNoAnswer !== undefined){
            this.props.onNoAnswer();
        }
    }

    getModalClassName() {
        if(this.props.className)
            return this.props.className
        else
            return "modal-body"
    }

    renderButton() {
        if(this.props.skipRenderButton)
            return null;

        const faIcon = this.props.buttonIconName ? <FaIcon iconName={this.props.buttonIconName}/> : null
        const text = this.props.buttonText
        const className = this.props.buttonClassName
        const buttonTitle = this.props.buttonTitle !== undefined ? this.props.buttonTitle : "";
        if(className)
            return (<Button className={className} onClick={this.toggle} title={buttonTitle} style={this.props.buttonStyle}>{faIcon}{text}</Button>)
        else
            return (<button onClick={this.toggle} style={this.props.buttonStyle} title={buttonTitle}>{faIcon}{text}</button>)
    }

    render() {
        return (<span>
                    {this.renderButton()}
                    <Modal key="modal" isOpen={this.state.modal} toggle={this.toggle} className={this.getModalClassName()}>
                        {this.renderModalHeader()}
                        <div className="modal-section">
                            {this.renderMessage()}
                            <p>{this.props.question}</p>
                        </div>
                        <ModalFooter>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                textAlign: "center",
                                clear:"both"
                            }}>
                                <div style={{margin:"0 10px"}}><input onClick={this.handleNoAnswer} type="button" value="No" className="btn -alt"/></div>
                                <SaveButton text={"Sí"} isSaving={this.props.isSaving} onClick={this.handleYesAnswer} hasChanges={true} />
                                {/*<div style={{margin:"0 10px"}}><input onClick={this.handleYesAnswer} type="button" value="Sí" className="btn -alt"/></div>*/}
                            </div>
                        </ModalFooter>
                    </Modal>
                </span>
        )
    }

    renderMessage() {
        if(this.props.message) {
            return (<p>{this.props.message}<br/><br/></p>)
        }
    }

    renderModalHeader () {
        if (this.props.title)
            return <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
    }
}
